<template>
  <div>
    <table-widget
      :items="items"
      :perPage="perPage"
      :totalRows="totalRows"
      :current-page.sync="currentPage"
      :filter.sync="filter"
    >
      <template slot="buttons">
        <b-button
          v-if="manage"
          class="mx-2"
          variant="primary"
          v-b-modal.projects-modal
          @click="selectedProjects = null"
          ><font-awesome-icon icon="plus" /> Manage Projects</b-button
        >
      </template>
      <template slot="content">
        <b-table
          striped
          :items="items"
          :fields="fields"
          :per-page="perPage"
          :current-page="currentPage"
          :filter="filter"
          @filtered="onFiltered"
          show-empty
          small
        >
          <template v-slot:cell(name)="data">
            <router-link
              :to="{ name: 'project', params: { id: data.item.id } }"
              >{{ data.item.title }}</router-link
            >
          </template>

          <template v-slot:cell(primaryInvestigator)="data">
            <div v-if="data.item.primaryInvestigator">
              {{ data.item.primaryInvestigator.firstName }}
              {{ data.item.primaryInvestigator.lastName }}
            </div>
          </template>

          <template v-slot:cell(location)="data">
            {{ data.item.location }}
          </template>
          <template v-slot:cell(startDate)="data">
            {{ data.item.startDate | formatDate }}
          </template>
          <template v-slot:cell(endDate)="data">
            {{ data.item.endDate | formatDate }}
          </template>
          <template v-slot:cell(type)="data">
            <div v-if="data.item.projectType">
              {{ data.item.projectType.name }}
            </div>
          </template>
          <template v-slot:cell(status)="data">
            <div v-if="data.item.status">
              {{ data.item.status.name }}
            </div>
          </template>
          <template v-slot:cell(details)="data">
            <router-link :to="{ name: 'project', params: { id: data.item.id } }"
              >Details</router-link
            >
          </template>
        </b-table>
      </template>
    </table-widget>
    <b-modal
      id="projects-modal"
      title="Add Projects"
      v-model="showForm"
      hide-footer
    >
      <b-form class="form-horizontal" @submit="save">
        <b-form-group label="" label-class="control-label">
          <!-- <autocomplete-form
            v-model="form.items"
            :displayFunction="displayItem"
            :selectFunction="update"
            :tableDisplayFunction="displayItem"
            apiPath="/api/Projects?search="
            objectName="Project"
            objectKey="projectId"
          > -->
          <autocomplete-form
            v-model="form.items"
            :displayFunction="displayItem"
            :tableDisplayFunction="displayItem"
            apiPath="/api/Projects?search="
            objectName="Project"
          >
            <template slot="fields">
              <b-form-group label="" label-class="control-label">
                <!-- <b-form-select
                  v-model="selectedRole"
                  :options="roles"
                  value-field="id"
                  placeholder="Select a role"
                  text-field="name"
                >
                  <template slot="first">
                    <option :value="null">Select a role or leave blank</option>
                  </template>
                </b-form-select> -->
              </b-form-group>
            </template>

            <template v-slot:buttons>
              <div class="modal-footer">
                <b-btn variant="secondary" @click="showForm = false"
                  >Cancel</b-btn
                >
                <b-btn type="submit" variant="primary">Save</b-btn>
              </div>
            </template>
          </autocomplete-form>
        </b-form-group>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import * as _ from "lodash";
import TableWidget from "../table-widget";
// import AwardsForm from "../experts/awards-form";
import AutocompleteFormWrapper from "../autocomplete-form-wrapper";
import projectApi from "../../api/projects";

export default {
  data() {
    return {
      form: {
        items: [],
      },
      // selectedRole: null,
      // roles: [],

      fields: [
        { key: "title", sortable: true },
        { key: "primaryInvestigator", sortable: true },
        { key: "location", sortable: true },
        { key: "status", sortable: true },
        { key: "type", sortable: true },
        { key: "startDate", sortable: true },
        { key: "endDate", sortable: true },
        { key: "details", label: "" },
      ],
      currentPage: 1,
      perPage: 20,
      filter: null,
      totalRows: 0,
      showForm: false,
      selectedProjects: null,
      // projectCollaboratorRole: null,
      // projectCollaboratorRoleId: 0,
      employee: null,
      primaryInvestigator: null,
    };
  },

  props: {
    items: {
      type: Array,
      required: true,
    },
    manage: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },

  components: {
    "table-widget": TableWidget,
    "autocomplete-form": AutocompleteFormWrapper,
  },

  methods: {
    update(autoselectResponse) {
      var found = _.find(this.items, (selectedItem) => {
        return selectedItem.id === autoselectResponse.selectedObject.projectId;
      });

      if (!found) {
        // var role = _.find(this.roles, (role) => {
        //   return role.id === this.selectedRole;
        // });
        this.items.push({
          // projectCollaboratorRoleId: this.selectedRole
          //   ? this.selectedRole
          //   : null,
          // projectCollaboratorRole: this.selectedRole
          //   ? {
          //       id: this.selectedRole ? this.selectedRole : 0,
          //       name: role ? role.name : "",
          //     }
          //   : null,
          project: autoselectResponse.selectedObject,
        });
      }

      this.$emit("input", this.items);
    },

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    reset() {
      this.form.items = this.items;
    },
    save() {
      event.preventDefault();
      this.$emit("save", this.form.items);
      this.showForm = false;
    },
    displayItem(item) {
      return item.title;
    },
  },

  watch: {
    items: function () {
      if (this.items) {
        this.form.items = _.clone(this.items);
      }
    },
  },
  created() {
    if (this.items) {
      this.form.items = _.clone(this.items);
    }

    console.log("HELLO");
    console.log(this.form.items);
    console.log("WORLD");

    // projectApi.getRoles().then((response) => {
    //   this.roles = response.data;
    // });
  },
};
</script>

<style scoped>
.form-horizontal {
  font-size: 13px;
}

.award-badge {
  cursor: pointer;
}

.badge-primary {
  background-color: #428bca;
  margin: 3px;
  padding: 5px;
}

.award-list {
  font-size: 16px;
}
table {
  font-size: 10pt;
}
</style>
